// extracted by mini-css-extract-plugin
module.exports =  {"inputComponent":"vtrACqE4r5qIHDYXYhK0","label":"Raf63NNBjXXEgTJx6aRM","alternativeLabel":"BbnnNh0qZjY1kgv875gQ"};